






















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { TaskStatus } from 'admiral-core';

@Component({ name: 'TaskStatusIcon' })
export default class TaskStatusIcon extends Vue {
  @Prop({ type: String, required: true }) status!: TaskStatus;
  @Prop({ type: String, default: 'md' }) size!: 'sm' | 'md' | 'lg';

  get sizeClass(): string {
    const map = { sm: 'size-sm', md: 'size-md', lg: 'size-lg' };
    return map[this.size] || 'size-md';
  }
}
